<template>
    <footer class="footer py-60 py-lg-90">
        <v-container>
            <v-row>
                <v-col cols="12" lg="7" class="d-flex flex-column justify-space-between mb-20 mb-lg-0">
                    <div class="footer-logo mb-20 mb-lg-0"></div>
                    <p>Copyright 2022. KIE SYSTEMS CO.,LTD. all rights reserced.</p>
                </v-col>
                <v-col cols="12" lg="5">
                    <ul class="footer-info pl-lg-60">
                        <li class="d-flex align-center mb-12 mb-lg-24">
                            <i class="icon icon-mail mr-12 mr-lg-24"></i>
                            <p>info@kiesys.co.kr</p>
                        </li>
                        <li class="d-flex align-center mb-12 mb-lg-24">
                            <i class="icon icon-tel mr-12 mr-lg-24"></i>
                            <p>+82-(0)31-906-9053/9054</p>
                        </li>
                        <li class="d-flex align-center mb-12 mb-lg-24">
                            <i class="icon icon-fax mr-12 mr-lg-24"></i>
                            <p>+82-(0)31-624-4035</p>
                        </li>
                        <li class="d-flex align-center">
                            <router-link to="/aboutus/location/paju" class="d-flex align-center">
                                <i class="icon icon-place mr-12 mr-lg-24"></i>
                                <p>17, Gyoha-ro 863 beon-gil Paju-si, Gyeonggi-do, Korea (10880)</p>
                            </router-link>
                        </li>
                    </ul>
                </v-col>
            </v-row>
        </v-container>
    </footer>
</template>

<script>
import UScrollTop from "@/components/dumb/u-scroll-top.vue";
export default {
    components: {
        UScrollTop,
    },
    data() {
        return {
            // site : null,
            // sites : [
            //     {
            //         name:"네이버",
            //         link:"https://www.naver.com/"
            //     },
            //     {
            //         name:"다음",
            //         link:"https://www.daum.net/"
            //     },
            // ]
        };
    },
    mounted() {},
    methods: {
        // changeD : function() {
        //     window.open(this.site, '_blank');
        // }
    },
};
</script>

<style scoped>
.footer {
    color: #666;
    background-color: #111;
    font-size: 1.2rem;
}

.footer-logo {
    width: 170px;
    height: 55px;
    background-image: url(/images/ci-ft_w.svg);
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
}

@media (min-width: 576px) {
}
@media (min-width: 768px) {
}
@media (min-width: 1024px) {
    .footer {
        font-size: 1.4rem;
    }
    .footer-logo {
        width: 290px;
        height: 94px;
    }
    .footer-info {
        border-left: 1px solid rgba(255, 255, 255, 0.15);
    }
}
@media (min-width: 1200px) {
}
</style>
